import { Trans, useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from 'designSystem/components/Select'
import type { LotoReportSummary } from 'features/lotoReports/lotoReportSummaries'
import type { ReactElement } from 'react'

import { LotoReportOptionText } from './lotoPagePanel.styles'

export const NEW_LOTO_DRAFT_VALUE = 'new-loto-draft'

type LotoReportSelectProps = {
  value: string
  onPage: LotoReportSummary[]
  others: LotoReportSummary[]
  disabled: boolean
  onChange: (value: string) => void
}

function ReportGroup({
  label,
  reports,
}: {
  label: string
  reports: LotoReportSummary[]
}): ReactElement | null {
  if (reports.length === 0) return null
  return (
    <SelectGroup>
      <SelectLabel>{label}</SelectLabel>
      {reports.map(({ id, name }) => (
        <SelectItem key={id} value={id}>
          <LotoReportOptionText>{name}</LotoReportOptionText>
        </SelectItem>
      ))}
    </SelectGroup>
  )
}

export function LotoReportSelect({
  value,
  onPage,
  others,
  disabled,
  onChange,
}: LotoReportSelectProps): ReactElement {
  const { t } = useLingui()
  return (
    <Box display='flex' minWidth='none'>
      <Select value={value} disabled={disabled} onValueChange={onChange}>
        <SelectTrigger size='sm' width='full' aria-label={t`LOTO report`}>
          <SelectValue placeholder={t`Choose a LOTO`} />
        </SelectTrigger>
        <SelectContent position='popper'>
          <ReportGroup label={t`On this page`} reports={onPage} />
          <ReportGroup label={t`Other LOTOs`} reports={others} />
          {onPage.length + others.length > 0 && <SelectSeparator />}
          <SelectItem value={NEW_LOTO_DRAFT_VALUE}>
            <Trans>New LOTO report…</Trans>
          </SelectItem>
        </SelectContent>
      </Select>
    </Box>
  )
}
